module.exports = __webpack_public_path__ + "static/media/124-upload.d7c8385d.svg";